import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Card, Image } from 'semantic-ui-react';
import { Event } from '../../types';
import { backgroundColour, cardStyle, eventDescription, textColour } from '../../utils';
import { GlobalContext } from '../App/GlobalContext';
import { Markdown } from '../Shared';

interface Props {
  event: Event;
}

class EventCard extends PureComponent<Props> {
  public render() {
    const { event } = this.props;
    return (
      <GlobalContext.Consumer>
        {({ darkMode }) => (
          <Card as={Link} to={`/event/${event.id}`} style={cardStyle(darkMode)}>
            <Image src={`/img/event/${event.id}.jpg`} width={290} height={290} alt={event.name} />
            <Card.Content style={backgroundColour(darkMode)}>
              <Card.Header style={textColour(darkMode)}>{event.name}</Card.Header>
              <Card.Description style={textColour(darkMode)}>
                <Markdown markdown={eventDescription(event, true)} />
              </Card.Description>
            </Card.Content>
          </Card>
        )}
      </GlobalContext.Consumer>
    );
  }
}

export default EventCard;
export { EventCard };
